import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import * as Search from '@app/models/search';
import { ApprovalsSearchService } from '@app/services/app/approvals.service';

@Component({
  selector: 'approvals-search-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class ApprovalsSearchMainComponent implements OnInit {

  public appliedFilters: Search.SearchAppliedFilter[] = [];
  public term: string = "";

  private appliedFiltersSubscription: Subscription;
  private termSubscription: Subscription;
  
constructor(private searchSrv: ApprovalsSearchService    ){}

  ngOnInit() {
    this.appliedFiltersSubscription = this.searchSrv.selectFilters().subscribe((filters: Search.SearchAppliedFilter[]) => this.appliedFilters = filters);
    this.termSubscription = this.searchSrv.selectTerm().subscribe((term: string) => this.term = term );
  }

  ngOnDestroy() {
      this.appliedFiltersSubscription.unsubscribe();
      this.termSubscription.unsubscribe();
  }

  onRemove(filter: Search.SearchAppliedFilter){
      // console.log(" remove filter... ",filter);
      this.searchSrv.removeFilter(filter);
  }

  onSetTerm(term: string) {
      this.searchSrv.setTerm(term);
  }

}
